import { render, staticRenderFns } from "./RedeemTicket.vue?vue&type=template&id=cbc6bb98&scoped=true&"
import script from "./RedeemTicket.vue?vue&type=script&lang=js&"
export * from "./RedeemTicket.vue?vue&type=script&lang=js&"
import style0 from "./RedeemTicket.vue?vue&type=style&index=0&id=cbc6bb98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbc6bb98",
  null
  
)

export default component.exports